
import { CalculatorFormValues } from '@/components/calculator/CalculatorForm';

export interface CalculationResult {
  prijs: number;
  totaal: number;
  maxAfspraken: number;
  overschreden: boolean;
  verwachteOmzet: number;
  roi: number;
}

export const calculateResults = (values: CalculatorFormValues): CalculationResult => {
  // Basis prijs per lead
  const basisPrijs = 250; 
  let prijsPerLead = basisPrijs;
  
  // Doelgroep factor
  if (values.doelgroep === 'bouw') prijsPerLead += 10;
  if (values.doelgroep === 'retail') prijsPerLead += 5;
  if (values.doelgroep === 'anders') prijsPerLead += 15;
  
  // Regio factor
  if (values.regio === 'heel-belgie') prijsPerLead += 7;
  
  // CRM integratie
  if (values.crmIntegratie === 'ja') prijsPerLead += 3;
  
  // Contactpersonen
  if (values.contactpersonen === 'meerdere') prijsPerLead += 8;
  
  // Taal
  if (values.taal === 'frans' || values.taal === 'engels') prijsPerLead += 5;
  if (values.taal === 'meertalig') prijsPerLead += 12;
  
  // DMU complexiteit
  if (values.dmuComplexiteit === 'complex') prijsPerLead += 15;
  
  // Product complexiteit
  if (values.productComplexiteit === 'hoog') prijsPerLead += 15;
  
  // Leads type
  if (values.leadsType === 'cold') prijsPerLead -= 8;
  
  // Volume korting
  const afspraken = Number(values.afspraken);
  if (afspraken >= 20) prijsPerLead *= 0.95;
  if (afspraken >= 30) prijsPerLead *= 0.9;
  
  // Markt limiet berekenen
  const marktgrootte = Number(values.marktgrootte);
  const conversiePercentage = Number(values.conversiePercentage) / 100;
  const campagneDuur = Number(values.campagneDuur);
  
  const maxAfsprakenTotaal = Math.round(marktgrootte * conversiePercentage);
  const maxAfsprakenPerMaand = Math.round(maxAfsprakenTotaal / campagneDuur);
  const overschreden = afspraken > maxAfsprakenPerMaand;
  
  const totaal = prijsPerLead * afspraken;
  
  // Berekeningen voor ROI
  const offertePercentage = Number(values.offertePercentage) / 100;
  const dealValue = Number(values.dealValue);
  const closingPercentage = Number(values.closingPercentage) / 100;
  
  // Bereken verwachte omzet
  const verwachteOffertes = afspraken * offertePercentage;
  const verwachteDeals = verwachteOffertes * closingPercentage;
  const verwachteOmzet = verwachteDeals * dealValue;
  
  // ROI berekening (omzet / kosten) * 100%
  const roi = (verwachteOmzet / totaal) * 100;
  
  return {
    prijs: Math.round(prijsPerLead),
    totaal: Math.round(totaal),
    maxAfspraken: maxAfsprakenPerMaand,
    overschreden,
    verwachteOmzet: Math.round(verwachteOmzet),
    roi: Math.round(roi)
  };
};
